import { type OptionsFetchQueryResult, OptionsType } from '@openx/types/options.ts';
import type { UseQueryOptions } from '@openx/types/reactQuery.ts';
import { useTranslation } from 'react-i18next';

import { useOptionsFetch } from './generics/useOptionsFetch.tsx';

export function useVideoFormatOptionsFetch(queryOptions?: UseQueryOptions<OptionsFetchQueryResult>) {
  const { t } = useTranslation();
  const {
    data: videoFormats,
    isLoading: isVideoFormatLoading,
    refetch: refetchVideoFormat,
  } = useOptionsFetch({
    errorMessage: t('Failed to fetch video format options'),
    mapByKey: 'legacy_id',
    optionType: OptionsType.VIDEO_FORMAT,
    queryOptions,
  });

  return {
    isVideoFormatLoading,
    refetchVideoFormat,
    videoFormats,
  };
}
